import React from 'react';
import LeadForm from '../components/LeadForm';
import './Contact.css';

const Contact = () => {
  return (
    <>
      <section 
        id="hero" 
        className="d-flex align-items-center hero-section"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(15, 23, 42, 0.45) 0%, rgba(30, 41, 59, 0.35) 100%), url('/assets/img/hero.webp')`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundBlendMode: "overlay",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6 d-flex flex-column justify-content-center pt-4 pt-lg-0 order-2 order-lg-1" data-aos="fade-up" data-aos-delay="200">
              <h1>Contact Us</h1>
            </div>
            <div className="col-lg-6 order-1 order-lg-2 hero-img" data-aos="zoom-in" data-aos-delay="200">
              <img src="" className="img-fluid animated" alt="" />
            </div>
          </div>
        </div>
      </section>

      {/* <section id="clients" className="clients section-bg">
        <div className="container">
          <div className="row" data-aos="zoom-in">
            <div className="col-lg-2 col-md-4 col-6 d-flex flex-column align-items-center justify-content-center">
              <img src={Clients1} className="img-fluid" alt="" />
            </div>
            <div className="col-lg-2 col-md-4 col-6 d-flex flex-column align-items-center justify-content-center">
              <img src={Clients2} className="img-fluid" alt="" />
            </div>
            <div className="col-lg-2 col-md-4 col-6 d-flex flex-column align-items-center justify-content-center">
              <img src={Clients3} className="img-fluid" alt="" />
            </div>
            <div className="col-lg-2 col-md-4 col-6 d-flex flex-column align-items-center justify-content-center">
              <img src={Clients4} className="img-fluid" alt="" />
            </div>
            <div className="col-lg-2 col-md-4 col-6 d-flex flex-column align-items-center justify-content-center">
              <img src={Clients5} className="img-fluid" alt="" />
            </div>
            <div className="col-lg-2 col-md-4 col-6 d-flex flex-column align-items-center justify-content-center">
              <img src={Clients6} className="img-fluid" alt="" />
            </div>
          </div>
        </div>
      </section> */}

      <section id="contact" className="contact">
        <div className="container" data-aos="fade-up">
          <div className="row">
            <div className="col-md-6">
              <div className="contact-form">
                <h4>Fill up the form and we will get back to you</h4>
                <LeadForm
                  title=""
                  subtitle=""
                  source="contact-page"
                  compact
                  buttonClassName="btn btn-primary"
                />
              </div>
            </div>
            <div className="col-md-6">
              <h4>Contact Details</h4>
              <ul className="contact-details">
                <li><strong>Address 1</strong></li>
                <li>No6401 31ST ST S APT 112, SAINT PETERSBURG, FL 33712 US</li>
                <li>2296 Henderson Mill Rd #116, Atlanta, GA 30345</li>
                <li><strong>Email</strong></li>
                <li>support@itassistexperts.com</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
